import { render, staticRenderFns } from "./InventairePanel.vue?vue&type=template&id=5718fbf3"
import script from "./InventairePanel.vue?vue&type=script&lang=ts"
export * from "./InventairePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports